import React, { Component, Fragment } from "react";

import { connect } from "react-redux";
import queryString from "query-string";
import cn from "classnames";

import style from "./VariantPage.module.scss";
import { ReactComponent as ClosedIcon } from "Assets/closeSideBar.svg";
import { ReactComponent as OpenedIcon } from "Assets/openSideBar.svg";

import SideBarLayout from "Pages/singleTestPage/components/sideBarLayout";
import IgvAlertPopup from "Pages/singleTestPage/components/igvAlertPopup/IgvAlertPopup";

import VariantPageHeader from "variantComponents/variantPageHeader";
import ExternalResources from "variantComponents/externalResources";
import ClassificationHistoryTable from "variantComponents/classificationHistoryTable";
import EvidenceContainer from "variantComponents/evidenceContainer";
import VariantConflictsPendingNotifications from "variantComponents/variantConflictsPendingNotifications";
import Spinner from "GenericComponents/spinner";
import SimpleSelect from "GenericComponents/simpleSelect";

import {
  getExternalResources,
  getGermlineEvidence,
  getHistoryGermline,
  getHistorySomatic,
  getLoadingStatus,
  getSomaticEvidence,
  getVariantData,
  // getZygosityType,
  getCurrentZygosityType,
  getSelectedZygosityType,
  getVariantId,
  getVariantPageTestId,
  getIgvAlertShow,
  getTestsList,
  getTestIsExported,
  getSelectedCurrentClassificationHistoryPhenotype,
  getCurrentClassificationHistoryPhenotypes,
} from "Store/selectors";
import {
  fetchEvidenceData,
  fetchVariantMetadataData,
  setExternalResources,
  setSelectedZygosityType,
  setTestInformation,
  fetchClassificationHistory,
  clearVariantPage,
} from "Actions/variantPageActions";
import {
  fetchVariantConflicts,
  pushVariantUsedConflict,
  clearVariantConflicts
} from 'Actions/variantConflictsActions';
import {
  setCurrentClassificationHistoryPhenotype
} from "Actions/variantPageActions";
import { goToChrPositionIgv } from "Actions/igvActions";
import { fetchTestMetadata } from "Actions/testActions";
import { fetchTests } from "Actions/testsActions";
import {
  GERMLINE_VARIANT_CLASS_OPTIONS,
  SOMATIC_VARIANT_CLASS_OPTIONS,
  TEXTS
} from "Utils/constants";
import {
  zygosityTypeByName
} from "Utils/helpers";

class VariantPage extends Component {
  constructor(props) {
    super(props);

    const {
      fetchEvidenceData,
      fetchVariantMetadataData,
      match,
      setSelectedZygosityType,
      setTestInformation,
      fetchTestMetadata,
      fetchTests
    } = props;
    const { testId, variantId } = match.params;
    const { selectedZygosityType } = queryString.parse(window.location.search);
    fetchTests();
    fetchVariantMetadataData({ testId, variantId });
    fetchEvidenceData(variantId);
    setSelectedZygosityType({ selectedZygosityType, testId, variantId });
    setTestInformation({ testId, variantId });
    fetchTestMetadata(testId);

    this.state = {
      sidebarToggle: true,
      isTestsList: false,
      isVariantConflictsFetched: false,
      isVariantUsedConflictPushed: false
    };
  }

  static getDerivedStateFromProps(props, state) {
    let returnedData = {};
    if (props.testsList.length > 0 && !state.isTestsList) {
      const {
        fetchClassificationHistory,
        match: {
          params: { variantId }
        }
      } = props;
      fetchClassificationHistory({ variantId, testsList: props.testsList });
      returnedData = { ...returnedData, isTestsList: true };
    }

    // get variant conflicts
    if (
      !state.isVariantConflictsFetched
      && props.currentZygosityType
      && props.testIsExported === false // important to be eqaul only false (not undefined or null or smthg else)
    ) {
      const {
        fetchVariantConflicts,
        match: {
          params: { testId, variantId }
        },
        currentZygosityType
      } = props;

      fetchVariantConflicts({
        testId,
        variantId,
        zygosityType: currentZygosityType
      });
      returnedData = { ...returnedData, isVariantConflictsFetched: true };
    }

    // push variant used conflict
    if (
      !state.isVariantUsedConflictPushed
      && props.currentZygosityType
      && props.testIsExported === false // important to be eqaul only false (not undefined or null or smthg else)
    ) {
      const {
        pushVariantUsedConflict,
        match: {
          params: { testId, variantId }
        },
        currentZygosityType
      } = props;

      pushVariantUsedConflict({
        testId,
        variantId,
        zygosityType: currentZygosityType
      });
      returnedData = { ...returnedData, isVariantUsedConflictPushed: true };
    }

    if (Object.keys(returnedData).length) {
      return returnedData;
    }
    return null;
  }

  componentWillUnmount() {
    const { clearVariantPage, clearVariantConflicts } = this.props;
    clearVariantPage();
    clearVariantConflicts();
  }

  handleClick = () => {
    this.setState({
      sidebarToggle: !this.state.sidebarToggle
    });
  };

  handelChrPosition = chrPosition => {
    this.props.goToChrPositionIgv(chrPosition);
  };

  handleCurrentClassificationHistoryPhenotype = e => {
    const { setCurrentClassificationHistoryPhenotype } = this.props;
    setCurrentClassificationHistoryPhenotype(e.target.value);
  }

  render() {
    const { sidebarToggle } = this.state;
    const {
      externalResources,
      variantData,
      selectedZygosityType,
      somaticEvidence,
      germlineEvidence,
      testId,
      variantId,
      isLoading,
      germlineClassHistory,
      somaticClassHistory,
      isIgvAlertShow,

      selectedCurrentClassificationHistoryPhenotype,
      currentClassificationHistoryPhenotypes,
    } = this.props;

    return (
      <div className={style["variant-page-wrapper"]}>
        {isLoading ? (
          <Spinner />
        ) : (
          <Fragment>
            <div
              className={cn([
                "links-wrapper",
                { "links-wrapper-open": sidebarToggle }
              ])}
            >
              <SideBarLayout
                handleClick={this.handleClick}
                mode={sidebarToggle}
                className={"external-resources"}
                iconOpened={<OpenedIcon />}
                iconClosed={<ClosedIcon />}
              >
                <ExternalResources
                  externalResources={externalResources}
                  selectedZygosityType={selectedZygosityType}
                />
              </SideBarLayout>
            </div>
            <div
              className={cn([
                "main-wrapper",
                { "links-wrapper-open": sidebarToggle }
              ])}
            >
              <div className="main-header-data">
                <VariantPageHeader
                  sidebarToggle={sidebarToggle}
                  variantData={variantData}
                  testId={testId}
                  variantId={variantId}
                  onChrPosition={this.handelChrPosition}
                />
              </div>
              <div className="main-data">
                <div
                  className={cn([
                    "conflict-notifications",
                    { "links-wrapper-open": sidebarToggle }
                  ])}
                >
                  <VariantConflictsPendingNotifications />
                </div>
                <div
                  className={cn([
                    "history",
                    { "links-wrapper-open": sidebarToggle }
                  ])}
                >
                  <div className={style['section-toolbar']}>
                    <div className="toolbar-title classification-history-title">Classification History</div>
                    <div className="toolbar-select">
                      <SimpleSelect
                        value={selectedCurrentClassificationHistoryPhenotype}
                        options={currentClassificationHistoryPhenotypes}
                        onChange={this.handleCurrentClassificationHistoryPhenotype}
                        isClearAvailable
                        placeholder="All phenotypes"
                      />
                    </div>
                  </div>
                  <ClassificationHistoryTable
                    data={
                      selectedZygosityType === TEXTS.somatic
                        ? somaticClassHistory
                        : germlineClassHistory
                    }
                    typeData={
                      selectedZygosityType === TEXTS.somatic
                        ? SOMATIC_VARIANT_CLASS_OPTIONS
                        : GERMLINE_VARIANT_CLASS_OPTIONS
                    }
                    testId={testId}
                  />
                </div>
                <div
                  className={cn([
                    "evidence",
                    { "links-wrapper-open": sidebarToggle }
                  ])}
                >
                  <EvidenceContainer
                    data={
                      selectedZygosityType === "somatic"
                        ? somaticEvidence
                        : germlineEvidence
                    }
                    typeData={
                      selectedZygosityType === "somatic"
                        ? SOMATIC_VARIANT_CLASS_OPTIONS
                        : GERMLINE_VARIANT_CLASS_OPTIONS
                    }
                  />
                </div>
              </div>
            </div>
            {!!isIgvAlertShow && <IgvAlertPopup />}
          </Fragment>
        )}
      </div>
    );
  }
}

VariantPage.propTypes = {};

const mapStateToProps = state => {
  return {
    variantData: getVariantData(state),
    germlineClassHistory: getHistoryGermline(state),
    somaticClassHistory: getHistorySomatic(state),
    somaticEvidence: getSomaticEvidence(state),
    germlineEvidence: getGermlineEvidence(state),
    externalResources: getExternalResources(state),
    // selectedZygosityType: getZygosityType(state),
    currentZygosityType: zygosityTypeByName(getCurrentZygosityType(state)),
    selectedZygosityType: getSelectedZygosityType(state),
    testId: getVariantPageTestId(state),
    isLoading: getLoadingStatus(state),
    variantId: getVariantId(state),
    isIgvAlertShow: getIgvAlertShow(state),
    testsList: getTestsList(state),
    testIsExported: getTestIsExported(state),
    selectedCurrentClassificationHistoryPhenotype: getSelectedCurrentClassificationHistoryPhenotype(state),
    currentClassificationHistoryPhenotypes: getCurrentClassificationHistoryPhenotypes(state),
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setResources: data => dispatch(setExternalResources(data)),
    fetchClassificationHistory: data => dispatch(fetchClassificationHistory(data)),
    fetchVariantMetadataData: data => dispatch(fetchVariantMetadataData(data)),
    fetchEvidenceData: data => dispatch(fetchEvidenceData(data)),
    setSelectedZygosityType: data => dispatch(setSelectedZygosityType(data)),
    setTestInformation: data => dispatch(setTestInformation(data)),
    goToChrPositionIgv: data => dispatch(goToChrPositionIgv(data)),
    fetchTestMetadata: id => dispatch(fetchTestMetadata(id)),
    fetchTests: () => dispatch(fetchTests()),
    clearVariantPage: () => dispatch(clearVariantPage()),
    fetchVariantConflicts: (data) => dispatch(fetchVariantConflicts(data)),
    pushVariantUsedConflict: (data) => dispatch(pushVariantUsedConflict(data)),
    clearVariantConflicts: () => dispatch(clearVariantConflicts()),
    setCurrentClassificationHistoryPhenotype: data => dispatch(setCurrentClassificationHistoryPhenotype(data)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VariantPage);
